// Interop-safe re-export of lottie-react.
//
// lottie-react ships dual CJS/ESM builds but declares no `exports` map. Under
// vite 8 / rolldown the (CJS-bundled) default export comes through as the module
// *namespace object* — `{ LottiePlayer, default: <Lottie fn>, … }` — rather than
// the `Lottie` component itself. Rendering that object throws React #130
// ("Element type is invalid … got: object", first seen in <Spinner>), which
// blanks the whole app.
//
// Importing the component through this module makes every call site robust: if
// the default arrived as the namespace object we reach into its `.default`;
// otherwise we use it as-is. Production builds resolve the same way, so the guard
// is consistent across dev and build.
//
// Usage: `import Lottie from '@core/lib/lottie'` (types come from here too). Do
// NOT import 'lottie-react' directly elsewhere.
import LottieImport from 'lottie-react'

type LottieComponent = typeof LottieImport

const candidate = LottieImport as unknown as { default?: LottieComponent }
const Lottie = (candidate && candidate.default ? candidate.default : LottieImport) as LottieComponent

export default Lottie
export type { LottieRefCurrentProps, LottieOptions } from 'lottie-react'
